import styled from "@emotion/styled";

export const TagStyled = styled("div")(({ colorStyles }) => ({
  backgroundColor: colorStyles.background,
  border: `1px solid ${colorStyles.border}`,
  color: colorStyles.textColor,
  svg: {
    fill: colorStyles.iconColor,
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "12px",
  width: "fit-content",
}));
